import { render, staticRenderFns } from "./UploadArquivo.vue?vue&type=template&id=58b8ca75"
import script from "./UploadArquivo.vue?vue&type=script&lang=js"
export * from "./UploadArquivo.vue?vue&type=script&lang=js"
import style0 from "./UploadArquivo.vue?vue&type=style&index=0&id=58b8ca75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports